<!--开通钱包页面-->
<template>
  <div class="home-container">
    <van-notice-bar
      v-if="applyInfo.statusDesc"
      left-icon="info-o"
      :text="applyInfo.statusDesc"
    />

    <van-form
      :class="isDisabledFormInput ? 'disableInput' : ''"
      @submit="onSubmit"
    >
      <van-field
        :value="ACCOUNT_TYPE_FOR_BANK_DESC[applyInfo.accountType]"
        required
        label="账户类型"
        right-icon="arrow"
        label-align="right"
        disabled
        label-width="100px"
        :class="isDisableAccountTypeSelect ? 'disableSomeInput' : ''"
        @click="onPopupModal(POPUP_MODAL_TYPE.accountType)"
      />

      <van-field
        v-model="applyInfo.accountName"
        required
        placeholder="请输入账户名称"
        :label="`${labelPreix}账户名称`"
        label-align="right"
        label-width="100px"
        :disabled="isDisabledFormInput || isAgentSign"
        :class="isAgentSign ? 'disableSomeInput' : ''"
      />

      <van-field
        v-model="applyInfo.bankCardNumber"
        required
        :label="`${labelPreix}银行卡号`"
        placeholder="请输入银行卡号"
        :right-icon="$isWXApplet?'':'photograph'"
        label-align="right"
        type="number"
        label-width="100px"
        :disabled="isDisabledFormInput"
        @click-right-icon="handleClickGetBankCard"
      />

      <van-field
        :value="CERTIFICATE_TYPE_DESC[applyInfo.certificateType]"
        required
        readonly
        :label="certificateTypeText.label"
        :placeholder="certificateTypeText.placeholder"
        label-align="right"
        right-icon="arrow"
        label-width="100px"
        :class="isAgentSign ? 'disableSomeInput' : ''"
        @click="onPopupModal(POPUP_MODAL_TYPE.certificate)"
      />

      <van-field
        v-model="applyInfo.certificateNumber"
        required
        :label="certificateNumberText.label"
        :placeholder="certificateNumberText.placeholder"
        :right-icon="!$isWXApplet&&applyInfo.certificateType === CERTIFICATE_TYPE.IdCard ? 'photograph' : ''"
        label-align="right"
        label-width="100px"
        :disabled="isDisabledFormInput || isAgentSign"
        :class="isAgentSign ? 'disableSomeInput' : ''"
        @click-right-icon="handleClickGetCardId"
      />

      <van-field
        :value="selectedBank.bankName"
        required
        readonly
        label="开户行"
        right-icon="arrow"
        label-align="right"
        label-width="100px"
        placeholder="请选择开户行"
        @click="onPopupModal(POPUP_MODAL_TYPE.bank)"
      />

      <van-field
        v-model="applyInfo.mobileNo"
        required
        label="预留手机号"
        placeholder="请输入银行预留手机号"
        label-align="right"
        type="tel"
        label-width="100px"
        :disabled="isDisabledFormInput"
      />

      <van-field
        v-if="isShowBranch"
        :value="selectedProvince.provinceName"
        required
        label="所在省份"
        right-icon="arrow"
        label-align="right"
        label-width="100px"
        placeholder="请选择所在省份"
        readonly
        @click="onPopupModal(POPUP_MODAL_TYPE.province)"
      />

      <van-field
        v-if="isShowBranch"
        :value="selectedSubBranch.branchName"
        required
        readonly
        label="支行名称"
        right-icon="arrow"
        label-align="right"
        label-width="100px"
        placeholder="请选择支行"
        @click="onPopupModal(POPUP_MODAL_TYPE.subBranch)"
      />

      <div
        v-if="userInfo.needSignCoop"
        class="agreement"
      >
        <van-checkbox v-model="isReadAgreement" />
        <div class="text">
          我已阅读并同意
          <span
            class="agreement-url"
            @click="toAgreement"
          >《美团钱袋宝支付服务协议》</span>
        </div>
      </div>

      <div class="button-group">
        <div
          v-if="isInWaitToConfirmMode"
          class="cancel"
          @click="onCancel"
        >
          拒绝并重新编辑
        </div>
        <van-button
          class="confirm"
          native-type="submit"
          :disabled="!isCanSubmit || isDisabledSubmit"
        >
          确认开通
        </van-button>
      </div>
    </van-form>

    <van-popup
      v-model="isShowSelectableAccountType"
      round
      position="bottom"
    >
      <van-picker
        title="选择账号类型"
        show-toolbar
        :columns="selectableAccountType"
        @confirm="onConfirmPopupModal($event, POPUP_MODAL_TYPE.accountType)"
        @cancel="isShowSelectableAccountType = false"
      />
    </van-popup>

    <van-popup
      v-model="isShowSelectableCertificateType"
      round
      position="bottom"
    >
      <van-picker
        v-if="isToThePublicAccount"
        title="选择证件类型"
        show-toolbar
        :columns="selectableCertificateTypeForPublic"
        @confirm="onConfirmPopupModal($event, POPUP_MODAL_TYPE.certificate)"
        @cancel="isShowSelectableCertificateType = false"
      />

      <van-picker
        v-else
        title="选择证件类型"
        show-toolbar
        :columns="selectableCertificateTypeForPrivate"
        @confirm="onConfirmPopupModal($event, POPUP_MODAL_TYPE.certificate)"
        @cancel="isShowSelectableCertificateType = false"
      />
    </van-popup>

    <ProvincePicker
      ref="provincePicker"
      @on-select-province="handleSelectProvince"
    />

    <BankPicker
      ref="bankPicker"
      @on-select-bank="handleSelectBank"
    />

    <SubBranchPicker
      ref="subBranchPicker"
      @on-select-subBranch="handleSelectSubBranch"
    />

    <van-popup
      v-model="isShowExitTimer"
      :close-on-click-overlay="false"
    >
      <div class="submitBox">
        <div class="submitTipText">
          <van-icon
            name="success"
            color="green"
          /> 已提交
        </div>
        <div>{{ secondLeftToExit }}秒后自动退出本页面</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Field from 'vant/lib/field';
import Form from 'vant/lib/form';
import Popup from 'vant/lib/popup';
import Picker from 'vant/lib/picker';
import Button from 'vant/lib/button';
import NoticeBar from 'vant/lib/notice-bar';
import Checkbox from 'vant/lib/checkbox';
import Icon from 'vant/lib/icon';
import { chooseImage } from '@/util/knb';
import ProvincePicker from '@/views/wallet/ProvincePicker';
import BankPicker from '@/views/wallet/BankPicker';
import SubBranchPicker from '@/views/wallet/SubBranchPicker';
import STATUS from '@/constants/status';
import {
  ACCOUNT_TYPE_FOR_BANK,
  ACCOUNT_TYPE_FOR_BANK_DESC,
  CERTIFICATE_TYPE,
  CERTIFICATE_TYPE_DESC,
  SIGNER_TYPE,
  WALLET_STATUS,
  QUALIFICATION_TYPE,
} from '@/constants/wallet';

import createWalletApi from '@/api/createWallet';

import 'vant/lib/field/style';
import 'vant/lib/form/style';
import 'vant/lib/popup/style';
import 'vant/lib/button/style';
import 'vant/lib/picker/style';
import 'vant/lib/notice-bar/style';
import 'vant/lib/checkbox/style';
import 'vant/lib/icon/style';

const POPUP_MODAL_TYPE = {
  accountType: 1,
  certificate: 2,
  province: 3,
  bank: 4,
  subBranch: 5,
};

export default {
  name: 'CreateWallet',
  components: {
    [Field.name]: Field,
    [Form.name]: Form,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Button.name]: Button,
    [NoticeBar.name]: NoticeBar,
    [Checkbox.name]: Checkbox,
    [Icon.name]: Icon,
    ProvincePicker,
    BankPicker,
    SubBranchPicker,
  },
  data() {
    return {
      POPUP_MODAL_TYPE,
      ACCOUNT_TYPE_FOR_BANK,
      ACCOUNT_TYPE_FOR_BANK_DESC,
      CERTIFICATE_TYPE,
      CERTIFICATE_TYPE_DESC,

      applyInfo: {
        accountType: 0,
        accountName: '',
        name: '',
        bankCardNumber: '',
        certificateType: 0,
        certificateNumber: '',
        provinceId: null,
        bankId: null,
        bankBranchId: null,
        branchName: '',
        mobileNo: '',
        statusDesc: '',
        status: WALLET_STATUS.WaitToInput,
        bankAccountId: null,
      },
      userInfo: {
        partnerId: '',
        needSignCoop: false,
        signerType: SIGNER_TYPE.Individual,
      },
      bankCardInfo: {},
      isReadAgreement: false,
      isShowSelectableAccountType: false,
      isShowSelectableCertificateType: false,
      selectableAccountType: [
        { text: '对公账户', value: ACCOUNT_TYPE_FOR_BANK.ToThePublic },
        { text: '对私账户', value: ACCOUNT_TYPE_FOR_BANK.ToThePrivate },
      ],
      selectableCertificateTypeForPrivate: [
        { text: '身份证', value: CERTIFICATE_TYPE.IdCard },
      ],
      selectableCertificateTypeForPublic: [
        { text: '企业营业执照/统一社会信用代码', value: CERTIFICATE_TYPE.BusinessLicense },
        { text: '事业单位法人证书', value: CERTIFICATE_TYPE.PubicInstitution },
      ],
      selectedProvince: {},
      selectedBank: {},
      selectedSubBranch: {},
      isShowExitTimer: false,
      secondLeftToExit: 5,
      isCanSubmit: false,
      bankWhiteList: [],
    };
  },
  computed: {
    //  代理人签约时限制部分编辑功能
    isAgentSign() {
      return this.userInfo.signerType === SIGNER_TYPE.Agent;
    },

    isIndividualSign() {
      return this.userInfo.signerType === SIGNER_TYPE.Individual;
    },

    isInWaitToConfirmMode() {
      return this.applyInfo.status === WALLET_STATUS.WaitToConfirm;
    },

    isShowBranch() {
      return this.isToThePublicAccount || (this.bankWhiteList.indexOf(this.applyInfo.bankId) === -1 && this.applyInfo.bankId);
    },

    isDisabledFormInput() {
      // 待确认和审核中都应该禁用整个表单输入
      return [WALLET_STATUS.WaitToConfirm, WALLET_STATUS.AUDITING].indexOf(this.applyInfo.status) !== -1;
    },

    isDisabledSubmit() {
      // 审核中禁用提交
      return [WALLET_STATUS.AUDITING].indexOf(this.applyInfo.status) !== -1;
    },

    isToThePublicAccount() {
      return this.applyInfo.accountType === ACCOUNT_TYPE_FOR_BANK.ToThePublic;
    },

    labelPreix() {
      const type = this.applyInfo.accountType;
      if (type === ACCOUNT_TYPE_FOR_BANK.ToThePublic) {
        return '对公';
      } else if (type === ACCOUNT_TYPE_FOR_BANK.ToThePrivate) {
        return '对私';
      } else {
        return '';
      }
    },

    /*
      从bankCardInfoDTO（重命名为bankCardInfo）中取，是最新的值，且当前逻辑中只有身份证可选
      当初次填写时从partnerInfoDTO（重命名为userInfo）中取值，并将applyInfo中的值取成partnerInfoDTO中的certificateType字段
      所以满足下面判断时一定是身份证验证类型
    */
    isCertificateByIdCard() {
      return this.bankCardInfo.certificateType === CERTIFICATE_TYPE.IdCard || this.userInfo.certificateType === CERTIFICATE_TYPE.IdCard;
    },

    isDisableAccountTypeSelect() {
      return this.isIndividualSign || (this.isAgentSign && !this.isCertificateByIdCard) || !this.hasQualification;
    },

    hasQualification() {
      return this.userInfo && this.userInfo.qualificationNumber;
    },

    certificateTypeText() {
      return this.isToThePublicAccount
        ? {
          label: '公司资质类型',
          placeholder: '请选择公司资质类型',
        }
        : {
          label: '证件类型',
          placeholder: '请选择证件类型',
        };
    },

    certificateNumberText() {
      return this.isToThePublicAccount
        ? {
          label: '公司资质编号',
          placeholder: '请输入账户名称对应的企业资质编号',
        }
        : {
          label: '证件编号',
          placeholder: '请输入身份证号，其他证件请联系业务员',
        };
    },
  },
  created() {
    this.getWalletInfo();
    this.getBankWhiteList();
  },
  methods: {
    async getBankWhiteList() {
      const { error, data } = await createWalletApi.getBankWhiteList();
      if (!error && data) {
        this.bankWhiteList = data || [];
      }
    },
    async getWalletInfo() {
      this.$store.commit('setLoading', true);
      try {
        const { respCode, data, respMsg } = await createWalletApi.getBankInfo();

        if (respCode !== STATUS.SUCCESS || !data) throw new Error(respMsg);

        const { bankCardInfoDTO: bankCardInfo = {}, partnerInfoDTO: userInfo = {} } = data;
        const {
          provinceName, provinceId, bankName, bankId, bankBranchId, branchName,
        } = bankCardInfo;

        this.userInfo = userInfo;
        this.bankCardInfo = bankCardInfo;
        this.selectedProvince = {
          provinceName,
          provinceId,
        };
        this.selectedBank = {
          bankId,
          bankName,
        };
        this.selectedSubBranch = {
          bankBranchId,
          branchName,
        };
        this.isCanSubmit = true;

        this.initApplyInfo();
      } catch (e) {
        this.$dialog.toast(e.message || '操作失败');
        this.applyInfo.statusDesc = e.message;
      } finally {
        this.$store.commit('setLoading', false);
      }
    },

    initApplyInfo() {
      const { qualificationType } = this.userInfo;
      const { type, number } = this.bankCardInfo;

      let accountType = type;

      if (this.isPublicQualification(qualificationType)) {
        accountType = accountType || ACCOUNT_TYPE_FOR_BANK.ToThePublic;
      } else {
        accountType = accountType || ACCOUNT_TYPE_FOR_BANK.ToThePrivate;
      }

      this.applyInfo = {
        ...this.bankCardInfo,
        accountType,
        bankCardNumber: number,
      };

      this.setDefaultAccountTypeForAgentSign();
      this.setDefaultValueForApplyInfo();
    },

    //  不是用身份证开通的代理人 限制成只能是对公账户
    setDefaultAccountTypeForAgentSign() {
      if (!this.isAgentSign) return;

      if (this.isCertificateByIdCard) return;

      this.applyInfo.accountType = ACCOUNT_TYPE_FOR_BANK.ToThePublic;
    },

    //  选取对公/对私账户类型时 如果之前已经录入过 切换选项时默认值要从userInfo中获取
    setDefaultValueForOtherAccountType() {
      const {
        qualificationName,
        qualificationType,
        signerName,
        identityCardNumber,
        certificateType: certificateTypeFromUserInfo,
        qualificationNumber,
      } = this.userInfo;

      let accountName;
      let certificateTypeForApply;
      let certificateNumberForApply;

      if (this.isToThePublicAccount) {
        accountName = qualificationName;
        certificateTypeForApply = qualificationType;
        certificateNumberForApply = qualificationNumber;
      } else {
        accountName = signerName;
        certificateTypeForApply = certificateTypeFromUserInfo;
        if (certificateTypeFromUserInfo === CERTIFICATE_TYPE.IdCard) {
          certificateNumberForApply = identityCardNumber;
        }
      }

      this.applyInfo = {
        ...this.applyInfo,
        accountName,
        certificateType: certificateTypeForApply,
        certificateNumber: certificateNumberForApply,
      };
    },

    //  选取对公/对私账户类型时 如果之前已经录入过 切换当前选中项时默认值要从bankCardInfo中获取
    //  bankCardInfo中没有时则从userInfo中获取
    setDefaultValueForApplyInfo() {
      const {
        qualificationName,
        qualificationType,
        signerName,
        identityCardNumber,
        certificateType: certificateTypeFromUserInfo,
        qualificationNumber,
      } = this.userInfo;
      const {
        name,
        certificateType: certificateTypeFromBankCard,
        certificateNumber: certificateNumberFromBankCard,
      } = this.bankCardInfo;

      let accountName = name;
      let certificateTypeForApply = certificateTypeFromBankCard;
      let certificateNumberForApply = certificateNumberFromBankCard;

      if (this.isToThePublicAccount) {
        accountName = accountName || qualificationName;
        certificateTypeForApply = certificateTypeForApply || qualificationType;
        certificateNumberForApply = certificateNumberForApply || qualificationNumber;
      } else {
        accountName = accountName || signerName;
        certificateTypeForApply = certificateTypeForApply || certificateTypeFromUserInfo;
        if (certificateTypeForApply === CERTIFICATE_TYPE.IdCard) {
          certificateNumberForApply = certificateNumberForApply || identityCardNumber;
        }
      }

      this.applyInfo = {
        ...this.applyInfo,
        accountName,
        certificateType: certificateTypeForApply,
        certificateNumber: certificateNumberForApply,
      };
    },

    setDefaultValueWhenSelectAccountType() {
      const { type: submittedAccountType } = this.bankCardInfo;
      if (this.applyInfo.accountType === submittedAccountType) {
        this.setDefaultValueForApplyInfo();
      } else {
        this.setDefaultValueForOtherAccountType();
      }
    },

    isPublicQualification(qualificationType) {
      return qualificationType === QUALIFICATION_TYPE.BusinessLicense
        || qualificationType === QUALIFICATION_TYPE.IndividualBusiness
        || qualificationType === QUALIFICATION_TYPE.PubicInstitution;
    },

    onPopupModal(modalType) {
      if (this.isDisabledFormInput) return;

      switch (modalType) {
      case POPUP_MODAL_TYPE.accountType:
        this.isShowSelectableAccountType = !this.isDisableAccountTypeSelect;
        break;
      case POPUP_MODAL_TYPE.certificate:
        this.isShowSelectableCertificateType = !this.isAgentSign;
        break;
      case POPUP_MODAL_TYPE.province:
        this.$refs.provincePicker.loadProvinceList();
        break;
      case POPUP_MODAL_TYPE.bank:
        this.$refs.bankPicker.loadBankList();
        break;
      case POPUP_MODAL_TYPE.subBranch:
        this.$refs.subBranchPicker.loadSubBranchList({
          provinceId: this.applyInfo.provinceId,
          bankId: this.applyInfo.bankId,
        });
        break;
      default:
        break;
      }
    },

    // eslint-disable-next-line complexity
    async handleClickGetBankCard() {
      this.$store.commit('setLoading', true);
      try {
        if (this.isDisabledFormInput) return;

        const imageList = await chooseImage();

        if (!imageList || imageList.length === 0) throw new Error('选取照片失败');

        if (imageList[0].size >= 7 * 1024 * 1024) {
          throw new Error('选择的图片不能超过7M');
        }

        const res = await createWalletApi.uploadImage(imageList[0]);
        const url = res && res.data && res.data.url;
        if (!url) throw new Error('上传照片失败');

        const { respCode, data, respMsg } = await createWalletApi.getBackNumberByUrl(url);

        if (respCode !== STATUS.SUCCESS || !data) throw new Error(respMsg);

        this.applyInfo.bankCardNumber = data.bankCardNo;
      } catch (e) {
        this.$dialog.toast(e.message || '操作失败');
      } finally {
        this.$store.commit('setLoading', false);
      }
    },

    // eslint-disable-next-line complexity
    async handleClickGetCardId() {
      if (this.isDisabledFormInput || this.isAgentSign) return;

      this.$store.commit('setLoading', true);

      try {
        const imageList = await chooseImage();

        if (!imageList || imageList.length === 0) throw new Error('选取照片失败');

        if (imageList[0].size >= 7 * 1024 * 1024) {
          throw new Error('选择的图片不能超过7M');
        }

        const res = await createWalletApi.uploadImage(imageList[0]);
        const url = res && res.data && res.data.url;
        if (!url) throw new Error('上传照片失败');

        const { respCode, data, respMsg } = await createWalletApi.getIdCardByUrl(url);

        if (respCode !== STATUS.SUCCESS || !data) throw new Error(respMsg);

        this.applyInfo.certificateNumber = data.citizenId;
      } catch (e) {
        this.$dialog.toast(e.message || '操作失败');
      } finally {
        this.$store.commit('setLoading', false);
      }
    },

    onConfirmPopupModal({ value: selectedOption }, modalType) {
      switch (modalType) {
      case POPUP_MODAL_TYPE.accountType:
        this.applyInfo.accountType = selectedOption;
        this.setDefaultValueWhenSelectAccountType();
        this.isShowSelectableAccountType = false;
        break;
      case POPUP_MODAL_TYPE.certificate:
        this.applyInfo.certificateType = selectedOption;
        this.isShowSelectableCertificateType = false;
        break;
      default:
        break;
      }
    },

    handleSelectProvince(province) {
      this.selectedProvince = province;
      this.applyInfo.provinceId = province.provinceId;
    },

    handleSelectBank(bank) {
      this.selectedBank = bank;
      this.applyInfo.bankId = bank.bankId;
    },

    handleSelectSubBranch(subBranch) {
      this.selectedSubBranch = subBranch;
      this.applyInfo.bankBranchId = subBranch.branchId;
      this.applyInfo.branchName = subBranch.branchName;
    },

    validateApplyInfo() {
      const keys = [
        'accountType', 'accountName', 'bankCardNumber', 'certificateType', 'certificateNumber', 'provinceId', 'bankId', 'bankBranchId', 'mobileNo',
      ];
      const phoneValidate = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      const isShowBranch = this.isShowBranch;
      const inOptional = (key) => ['provinceId', 'bankBranchId'].indexOf(key) > -1 && !isShowBranch;

      if (keys.some((key) => !this.applyInfo[key] && this.applyInfo[key] !== 0 && !inOptional(key))) {
        this.$dialog.toast('请将表单填写完整');
        return false;
      }

      if (!phoneValidate.test(this.applyInfo.mobileNo)) {
        this.$dialog.toast('请输入正确的手机号');
        return false;
      }

      return true;
    },

    checkIsSignAgreement() {
      if (!this.userInfo.needSignCoop) return true;

      if (this.isReadAgreement) return true;

      this.$dialog.toast('请先勾选《美团钱袋宝支付服务协议》');

      return false;
    },

    async onSubmit() {
      if (!this.validateApplyInfo()) return;

      if (!this.checkIsSignAgreement()) return;

      const { accountType, accountName, bankCardNumber } = this.applyInfo;
      const params = {
        ...this.applyInfo,
        type: accountType,
        name: accountName,
        number: bankCardNumber,
      };

      try {
        const { respCode, data, respMsg } = await createWalletApi.createWallet(params);

        if (respCode !== STATUS.SUCCESS || !data) throw new Error(respMsg);

        if (!data.result) throw new Error(respMsg);

        const keep = await this.isKeepPage();
        if (keep) {
          window.location.reload();
        } else {
          this.showTimerAndExit();
        }
      } catch (e) {
        this.$dialog.toast(e.message || '开通失败');
      }
    },

    async isKeepPage() {
      // 查询一次银行卡信息，看状态
      const { respCode, data, respMsg } = await createWalletApi.getBankInfo();

      if (respCode !== STATUS.SUCCESS || !data) throw new Error(respMsg);

      const { bankCardInfoDTO: bankCardInfo = {} } = data;

      // 需要停留在当前页面的状态列表。
      const keepPageStatus = [WALLET_STATUS.AUDITING];

      return keepPageStatus.indexOf(bankCardInfo.status) !== -1;
    },

    showTimerAndExit() {
      this.isShowExitTimer = true;
      const timer = setInterval(() => {
        if (this.secondLeftToExit <= 1) {
          clearInterval(timer);
          this.$router.go(-1);
        }

        this.secondLeftToExit = this.secondLeftToExit - 1;
      }, 1000);
    },

    async onCancel() {
      this.$store.commit('setLoading', true);
      try {
        const params = {
          bankAccountId: this.applyInfo.bankAccountId,
          partnerId: this.$store.getters['partnerModule/id'],
        };

        const { respCode, data, respMsg } = await createWalletApi.refuseCreateWallet(params);

        if (respCode !== STATUS.SUCCESS || !data) throw new Error(respMsg);

        if (!data.result) throw new Error('操作失败');

        this.$dialog.toast('操作成功');

        //  避免疯狂刷屏，晚一秒再刷新页面
        setTimeout(() => {
          this.$router.go(0);
        }, 1000);
      } catch (e) {
        this.$dialog.toast(e.message || '操作失败');
      } finally {
        this.$store.commit('setLoading', false);
      }
    },

    toAgreement() {
      this.$router.push('/qdbAgreement');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixin';
@import '@/assets/css/theme';
@include borderCreator("border1px-bottom", "bottom", solid, rgba(0, 0, 0, 0.12));

.home-container {
  padding-top: 0.18rem;

  .agreement {
    background: #fff;
    display: flex;
    justify-content: center;
    padding: 0.32rem;
    margin: 0.16rem 0;

    .text {
      margin-left: 0.08rem;
    }

    .agreement-url {
      color: #2a8efe;
    }
  }

  .button-group {
    margin-top: 0.16rem;
    display: flex;
    justify-content: center;
    color: #222;

    .cancel {
      margin-right: 0.32rem;
      background: $mt_yellow;
      cursor: pointer;
      height: 0.88rem;
      line-height: 0.82rem;
      padding: 0 0.3rem;
      position: relative;

      &:active::before {
        opacity: 0.1;
      }

      &::before {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        background-color: #000;
        border: inherit;
        border-color: #000;
        border-radius: inherit;
        transform: translate(-50%,-50%);
        opacity: 0;
        content: ' ';
      }
    }

    .confirm {
      background: $mt_yellow;
    }
  }

  .option {
    height: 1rem;
    line-height: 1rem;
    text-align: center;

    &:nth-last-of-type(1) {
      border-bottom: none;
    }
  }

  .disableInput {
    .van-cell {
      opacity: 0.6;
    }
  }

  .van-cell {
    &.disableSomeInput {
      opacity: 0.6;
    }
  }
}

.submitBox {
  padding: 0.32rem;

  .submitTipText {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.32rem;
  }
}
</style>
